<template>
  <section>
    <stop-cash-dialog
      v-if="disbursementOrder.disbursement"
      :value="true"
      :disbursementOrder="disbursementOrder"
      :token="token"
      hide-cancel
      persistent
    />
    <base-dialog
      :is-open="!!errorMessage"
      persistent
      :close-on-click-outside="false"
      :hide-closing-options="true"
      is-plain
    >
      <template #dialog-title>
        <div/>
      </template>
      <template #dialog-text>
        {{ errorMessage }}
      </template>
      <template #dialog-actions>

      </template>
    </base-dialog>
  </section>
</template>
<script>

import StopCashDialog from '@/components/evaluation/StopCashDialog.vue'
import BaseDialog from "@/components/UI/BaseDialog.vue"
import { pick } from 'lodash'
export default {
  components: {
    BaseDialog,
    StopCashDialog
  },
  props: {
    token: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      organizationName: null,
      collectionName: null,
      successMessage: null,
      disbursementOrder: {},
      errorMessage: null
    }
  },

  async mounted () {
    try {
      const organizationId = this.$route.query.organization_id
      const res = await this.$store.getters.restApi.get(`disbursementorder/order/secure_link/${this.token}/${organizationId}`)
      this.disbursementOrder = {
        name: res.data.collection_name,
        organization_name: res.data.organization_name,
        currency_symbol: res.data.currency_symbol,
        disbursement: pick(res.data, ["count_payments", "sum_amount_ecom", "sum_amount_pos", "sum_amount_cash", "stop_cash_payments", "sum_amount_total"])
      }
    } catch (e) {
      this.errorMessage = e.response.data?.message ?? 'Something went wrong'
    }
  },
}
</script>
